export const INVOICES_CACHE_KEY = 'invoices';
export const INVOICE_DETAILS_CACHE_KEY = 'invoice-details';
export const INVOICE_ITEMS_CACHE_KEY = 'invoice-items';
